var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        title: "CONFIRME A LOCALIZAÇÃO",
        subtitle: "Confirme a localização do endereço no mapa.",
        size: "md"
      }
    },
    [
      _c("template", { slot: "body" }, [
        _c("section", [
          _c("div", { staticClass: "google-map", attrs: { id: "map" } }),
          _vm._v(" "),
          _c("div", { staticClass: "pin" }),
          _vm._v(" "),
          _c("div", { staticClass: "map-title" }, [
            _vm._v("confirme sua localização")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "button-group" }, [
            _c(
              "div",
              {
                staticClass: "btn bg-pink radius",
                on: {
                  click: function($event) {
                    _vm.$emit("prev")
                  }
                }
              },
              [_vm._v("voltar")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "btn bg-purple radius",
                class: { "btn--loading": _vm.loader },
                on: {
                  click: function($event) {
                    _vm.submit()
                  }
                }
              },
              [_c("span", [_vm._v("confirmar")])]
            )
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34063957", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34063957","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Addresses/NewAddress/PinConfirmation.vue
// module id = null
// module chunks = 